import { defineStore } from 'pinia'
import { AppStoreEnum } from '#lib/enums'
import { DEFAULT_PROMOTION_USER } from '#lib/constants'
import type { PromotionUser, PromotionUserState } from '#lib/types'
import { persistedState } from '#imports'

export const useUserPromotionStore = defineStore(AppStoreEnum.UserPromotion, {
  state: (): PromotionUserState => ({
    promotionUser: { ...DEFAULT_PROMOTION_USER },
  }),
  persist: {
    storage: persistedState.localStorage,
  },
  actions: {
    setPromotionUser(data: PromotionUser) {
      this.promotionUser = data
    },
    resetPromotionUser() {
      this.promotionUser = { ...DEFAULT_PROMOTION_USER }
    },
    getPackageId() {
      return this.promotionUser?.plan?.package_id
    },
    getUserPlan() {
      return this.promotionUser?.plan
    },
  },
})
